module.exports = __webpack_public_path__ + "static/media/warning.c4d0d5af.svg";